/* tslint:disable */
/* eslint-disable */
/**
 * KDS API
 * Internal KDS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginRequestDeviceInfo
 */
export interface LoginRequestDeviceInfo {
    /**
     * 
     * @type {string}
     * @memberof LoginRequestDeviceInfo
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestDeviceInfo
     */
    platform: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestDeviceInfo
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestDeviceInfo
     */
    os: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestDeviceInfo
     */
    osVersion: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestDeviceInfo
     */
    appVersion: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequestDeviceInfo
     */
    appBuild: string;
}

/**
 * Check if a given object implements the LoginRequestDeviceInfo interface.
 */
export function instanceOfLoginRequestDeviceInfo(value: object): value is LoginRequestDeviceInfo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    if (!('model' in value) || value['model'] === undefined) return false;
    if (!('os' in value) || value['os'] === undefined) return false;
    if (!('osVersion' in value) || value['osVersion'] === undefined) return false;
    if (!('appVersion' in value) || value['appVersion'] === undefined) return false;
    if (!('appBuild' in value) || value['appBuild'] === undefined) return false;
    return true;
}

export function LoginRequestDeviceInfoFromJSON(json: any): LoginRequestDeviceInfo {
    return LoginRequestDeviceInfoFromJSONTyped(json, false);
}

export function LoginRequestDeviceInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginRequestDeviceInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'platform': json['platform'],
        'model': json['model'],
        'os': json['os'],
        'osVersion': json['osVersion'],
        'appVersion': json['appVersion'],
        'appBuild': json['appBuild'],
    };
}

export function LoginRequestDeviceInfoToJSON(json: any): LoginRequestDeviceInfo {
    return LoginRequestDeviceInfoToJSONTyped(json, false);
}

export function LoginRequestDeviceInfoToJSONTyped(value?: LoginRequestDeviceInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'platform': value['platform'],
        'model': value['model'],
        'os': value['os'],
        'osVersion': value['osVersion'],
        'appVersion': value['appVersion'],
        'appBuild': value['appBuild'],
    };
}

